import { useCallback } from 'react';
import { EventStatus } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/calendar_event.pb';
import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { useTranslation } from '@frontend/i18n';
import { useAlert } from '@frontend/design-system';

export const useUpdateAppointmentStatusV3 = () => {
  const { t } = useTranslation('appointment-status');
  const alert = useAlert();

  const updateStatusMutation = SchedulerV3.Mutations.useUpdateCalendarEventStatusMutation({
    options: {
      onSuccess: () => {
        alert.success(t('Appointment status updated'));
      },
      onError: () => {
        alert.error(t('Error updating appointment status'));
      },
    },
  });

  const handleUpdateStatus = useCallback(
    (payload: { eventId: string; status: EventStatus; existingStartDate?: string; existingReferenceId?: string }) => {
      updateStatusMutation.mutate(payload);
    },
    [updateStatusMutation]
  );

  return {
    handleUpdateStatus,
    isLoading: updateStatusMutation.isLoading,
  };
};
